<template>
    <jet-dialog-modal 
        :show="modalOpen" 
        ref="modal"
        @close="closeModal"
    >
        <template #title>
            Pending Changes Detected
        </template>

        <template #content>
            <div class="mb-4">
                <p class="text-gray-800 mb-4">
                    In order to continue with the selected plan, pending changes to your subscription must be cancelled:
                </p>

                <div class="space-y-3 mb-6">
                    <div 
                        v-for="change in pendingChanges" 
                        :key="change.type"
                        class="p-4 border rounded-lg"
                        :class="{
                            'border-red-200 bg-red-50': change.type === 'cancellation',
                            'border-orange-200 bg-orange-50': change.type === 'pause',
                            'border-blue-200 bg-blue-50': change.type === 'plan_change'
                        }"
                    >
                        <div class="flex items-start">
                            <div 
                                class="mr-3 mt-1 w-2 h-2 rounded-full flex-shrink-0"
                                :class="{
                                    'bg-red-500': change.type === 'cancellation',
                                    'bg-orange-500': change.type === 'pause', 
                                    'bg-blue-500': change.type === 'plan_change'
                                }"
                            ></div>
                            <div>
                                <h3 class="font-medium mb-1">
                                    {{ change.description }} scheduled for {{ change.date }}
                                </h3>
                                <p class="text-sm text-gray-600">
                                    {{ change.details }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
                    <div class="flex">
                        <font-awesome-icon 
                            :icon="['fas', 'exclamation-triangle']" 
                            class="text-yellow-600 mr-3 mt-1"
                        />
                        <div>
                            <h3 class="font-medium text-yellow-800">Warning</h3>
                            <p class="text-sm text-yellow-700 mt-1">
                                Proceeding will cancel the pending change above. 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <jet-button text @click="closeModal" class="mr-4">
                {{ keepButtonText }}
            </jet-button>

            <jet-button secondary @click="confirmAndProceed" :disabled="processing">
                <font-awesome-icon
                    :icon="['far', 'spinner']"
                    class="fa-spin mr-2"
                    v-show="processing"
                />
                {{ continueButtonText }}
            </jet-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
export default {
    emits: ['close', 'confirmed'],
    components: { },
    name: "PendingChangesConfirmModal",
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        pendingChanges: {
            type: Array,
            default: () => []
        },
        processing: {
            type: Boolean,
            default: false
        },
        keepButtonText: {
            type: String,
            default: 'Keep Pending Changes'
        },
        continueButtonText: {
            type: String,
            default: 'Cancel Pending & Continue Preview'
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        confirmAndProceed() {
            this.$emit('confirmed');
        }
    },
    computed: {
        modalOpen() {
            return this.isOpen;
        }
    }
}
</script>

<style scoped>
</style>